module.exports = __webpack_public_path__ + "static/media/ltd.3750b775.png";